<template>
  <v-alert class="AppAlert pa-4"
           :class="{ 'AppAlert--bordered': hasLeftBorder }"
           :color="backgroundColor"
           :closable="dismissible"
           :rounded="rounded"
           :style="{ borderLeftColor: color }"
           @update:model-value="$emit('input')"
  >
    <div class="d-flex align-start column-gap-4">
      <app-material-icon
        v-if="!noIcon"
        :name="computedIcon"
        :color="color"
        filled
      />
      <div class="d-flex align-center flex-grow-1">
        <div class="flex-grow-1">
          <p v-if="$slots['title']" class="text--small text--bold text-text-primary">
            <!-- @slot Use this slot for title -->
            <slot name="title"></slot>
          </p>
          <div class="text-text-secondary">
            <!-- @slot Use this slot for alert text -->
            <slot></slot>
          </div>
        </div>
        <div v-if="$slots['button']" >
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { AppAlertBackgroundColor, AppAlertColor, AppAlertIcon } from '@/design-system/alert/enums'
import { AppAlertVariant } from '@/design-system/alert/types'

/**
 * Alert in app component.
 * @displayName In Page
 */
export default defineComponent({
  name: 'AppAlertInPage',
  props: {
    /**
     * Variant of the Alert.
     * @values info, success, error or warning
     */
    variant: {
      type: String as PropType<AppAlertVariant>,
      default: 'info',
    },
    /**
     * Adds a close icon that can hide the alert
     */
     dismissible: {
      type: Boolean,
      default: true,
    },
    /**
     * Remove icon before the alert text
     */
     noIcon: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    hasLeftBorder: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedIcon () {
      if (this.iconName) {
        return this.iconName
      }
      return AppAlertIcon[this.variant].valueOf()
    },
    backgroundColor () {
      return AppAlertBackgroundColor[this.variant].valueOf()
    },
    color () {
      return AppAlertColor[this.variant].valueOf()
    },
  },
})
</script>

<style scoped lang="scss">
.AppAlert {
  &--bordered {
    border-left-width: 8px;
    border-left-style: solid;
    border-collapse: collapse;
  }
}
</style>
